import React from "react";

const Button = (props) => {
  const { form, disabled, isApp } = props;

  return (
    <div className="form__button-component-container" style={isApp ? { marginBottom: "48px" } : {}}>
      <button className={`form__button-component${disabled ? "--disabled" : ""}`} type="submit" disabled={disabled}>
        {form.button}
      </button>
    </div>
  );
};

export default Button;
